/* eslint-disable react/jsx-one-expression-per-line */
import Button from "components/Button";
import H3 from "components/H3";
import H5 from "components/H5";
import React, { useEffect } from "react";
import applicationSvc from "services/applicationSvc";
import styled from "styled-components";
import Svg from "_assets/svg";
import {useMutation} from '@tanstack/react-query';

const Img = styled.img`
  width: 20px;
  height: 20px;
`;

const ButtonClose = styled.a`
  background: transparent;
  cursor: pointer;
`;

const Wrapper = styled.div`
  position: fixed; /* Stay in place */
  z-index: 100;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
  display: ${(props) => (props.active ? "flex" : "none")};
  transition: opacity 0.5s linear;
  -webkit-transition: opacity 0.5s linear;
  -moz-transition: opacity 0.5s linear;
  -o-transition: opacity 0.5s linear;
  -ms-transition: opacity 0.5s linear;
`;
const Divider = styled.div`
  padding: 34px;
  border-radius: 8px;
`;

const ModalDelete = (props) => {
  // const [isLoading, setLoading] = useState(false);
  const { applicationName, showModal, handleClose, successDelete, id } = props;

  const {mutate: handleDelete, isLoading } = useMutation({
    mutationFn: async () => {
     const responseData = await applicationSvc.delete(id);
  
     return responseData;
    },
    onSuccess: () => {
      successDelete();
    },
    onError: () => {}
  })

  // const handleDelete = async () => {
  //   setLoading(true);
  //   try {
  //     await applicationSvc.delete(id);
  //     setLoading(false);
  //     successDelete();
  //   } catch (err) {
  //     setLoading(false);
  //   }
  // };
  useEffect(() => {
    document.body.style.overflow = showModal ? "hidden" : "auto";
  }, [showModal]);

  return (
    <Wrapper
      active={showModal}
      className="flex-row mx-auto align-items-center justify-content-center"
    >
      <div>
        <Divider className="modal-content">
          <div className="p-0 modal-body d-flex flex-column">
            <ButtonClose className="margin-bottom-25" onClick={handleClose}>
              <Img src={Svg.ic_close.default} />
            </ButtonClose>
            <H3 className="margin-bottom-10">Remove “{applicationName}”</H3>
            <H5 className="margin-bottom-30">Are you sure you want to remove this application?</H5>
            <div className="d-flex flex-row">
              <Button
                loading={isLoading === false}
                handleRoute={() => handleDelete()}
                primary
                className="margin-right-15"
              >
                Remove Application
              </Button>
              <Button handleRoute={handleClose}>Cancel</Button>
            </div>
          </div>
        </Divider>
      </div>
    </Wrapper>
  );
};

export default ModalDelete;
